__turbopack_context__.v({
  "link": "KuubFW_link",
  "list": "KuubFW_list",
  "listItem": "KuubFW_listItem",
  "listItemPenultimate": "KuubFW_listItemPenultimate",
  "root": "KuubFW_root",
  "separatorDesktop": "KuubFW_separatorDesktop",
  "separatorMobile": "KuubFW_separatorMobile",
});
